import type { T_ChatV8Capabilities } from "@lattice/core-lib/types/chat-v8";

export type T_ChatV8AttachmentKind = "csv" | "image" | "pdf" | "spreadsheet";

const MIME_TYPES_BY_KIND: Record<T_ChatV8AttachmentKind, readonly string[]> = {
  image: ["image/jpeg", "image/png", "image/webp"],
  pdf: ["application/pdf"],
  csv: ["text/csv", "application/csv", "text/plain"],
  spreadsheet: [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ],
};

/**
 * Attachment kinds the connected backend accepts. Absence of the
 * capability list means an older backend that only handles images.
 */
export function getSupportedChatV8AttachmentKinds(
  capabilities: Pick<
    T_ChatV8Capabilities,
    "supportedAttachmentKinds" | "supportsUserImageAttachments"
  > | null,
): T_ChatV8AttachmentKind[] {
  if (!capabilities) return [];
  if (capabilities.supportedAttachmentKinds) {
    return [...capabilities.supportedAttachmentKinds];
  }
  return capabilities.supportsUserImageAttachments === true ? ["image"] : [];
}

export function getAcceptedChatV8AttachmentMimeTypes(
  kinds: readonly T_ChatV8AttachmentKind[],
): string[] {
  return kinds.flatMap((kind) => [...MIME_TYPES_BY_KIND[kind]]);
}

export function getChatV8AttachmentKindForMimeType(
  kinds: readonly T_ChatV8AttachmentKind[],
  mimeType: string,
): T_ChatV8AttachmentKind | null {
  for (const kind of kinds) {
    if (MIME_TYPES_BY_KIND[kind].includes(mimeType)) return kind;
  }
  return null;
}
